import { Box, Link, Stack, styled } from '@/theme/index';

export const StyledFilterChips = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  borderRadius: '18px',
  border: `1px solid ${theme.palette.primary.light}`,
  fontSize: '14px',
  fontFamily: theme.typography.fontFamily,
  cursor: 'pointer',
  alignItems: 'center',
  display: 'flex',

  '&:hover': {
    backgroundColor: theme.palette.background.default,
  },

  [theme.breakpoints.down('sm')]: {
    marginLeft: '0 !important',
  },

  '&.selected-filter-chip': {
    background: 'rgba(0, 0, 0, 0.08)',
    border: 'none',
    color: theme.palette.text.primary,
    height: 'auto',
    padding: `1px ${theme.spacing(1)}`,
    marginLeft: theme.spacing(1),

    '&:hover': {
      backgroundColor: 'none',
    },

    '& .MuiSvgIcon-root': {
      marginLeft: theme.spacing(1),
      fontSize: '11px',
      padding: '2px',
      background: 'rgba(0, 0, 0, 0.2)',
      color: 'rgba(255, 255, 255, 0.7)',
      borderRadius: '50%',
    },
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: `${theme.palette.labelsAndLinks?.main || theme.palette.success.main}`,
  lineHeight: 1.2,
  textDecoration: 'underline',
  '&:hover': {
    color: `${theme.palette.labelsAndLinks?.dark || 'initial'}`,
  },
}));

export const StyledSuggestion = styled(Stack)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  backgroundColor: theme.palette.background.paper,
  padding: '5px 0',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: theme.palette.background.default,
  },
}));

export const SelectedFilterChips = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  borderRadius: '13px',
  border: `1px solid ${theme.palette.primary.light}`,
  fontSize: '14px',
  fontFamily: theme.typography.fontFamily,
  cursor: 'pointer',
  alignItems: 'center',
  display: 'flex',

  '&.selected-filter-chip': {
    background: 'rgba(0, 0, 0, 0.08)',
    border: 'none',
    color: theme.palette.text.primary,
    height: 'auto',
    padding: `1px ${theme.spacing(1)}`,
    marginLeft: theme.spacing(1),

    '& .MuiSvgIcon-root': {
      marginLeft: theme.spacing(1),
      fontSize: '11px',
      padding: '2px',
      background: 'rgba(0, 0, 0, 0.2)',
      color: 'rgba(255, 255, 255, 0.7)',
      borderRadius: '50%',
    },
  },
}));
